// extracted by mini-css-extract-plugin
export var consult = "index-module--consult--QqjxU";
export var ds2023Root = "index-module--ds2023Root--hMX5Y";
export var miniProgramQRcode = "index-module--miniProgramQRcode--dr3t7";
export var rightBtn = "index-module--rightBtn--evXUz";
export var rightNav = "index-module--rightNav--jH78v";
export var rightPoint = "index-module--rightPoint--sWXnZ";